import { EgiRoutes } from '@ervo/page-framework';
import { Routes } from '@angular/router';
import { AppRootIndexPageComponent } from '@/app/egi.pages/app-root.pages/app-root-index-page/app-root-index-page.component';
import { genericAppIndexId } from '@/app/egi.pages/app-root.pages/page-ids';

export const appRootNavigationRoutes: EgiRoutes & Routes = [
  {
    component: AppRootIndexPageComponent,
    path: '',
    data: {
      config: {
        id: genericAppIndexId,
        name: 'Geen',
        features: {},
        clickTroughPages: {}
      }
    }
  }
];
